import { State } from './ofwcaPath.types';

export const initState: State = {
  fields: null,
  relatedStations: null,
  signedDocuments: null,
};
